import { FieldType, FormField, PROMPTS, WidthClass } from '@thehubz/client/core';
import { Channel, Subject } from './vorwerk-metadata-config';

export const vorwerkFields: FormField[] = [
  {
    formTypeId: '3',
    formFieldName: 'channel',
    fieldType: FieldType.Dropdown,
    fieldLabel: $localize`Channel`,
    placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
    widthClass: WidthClass.WFull,
    fieldGroup: 'tagging',
    mandatory: true,
    value: undefined,
    dropDownSearch: true,
    options: Channel,
    visible: true,
  },
  {
    formTypeId: '3',
    formFieldName: 'subject',
    fieldType: FieldType.Dropdown,
    fieldLabel: $localize`Subject`,
    placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
    widthClass: WidthClass.WFull,
    fieldGroup: 'tagging',
    mandatory: true,
    value: undefined,
    dropDownSearch: true,
    options: Subject,
    visible: true,
  },
  {
    formTypeId: '4',
    formFieldName: 'exchange_link',
    fieldType: FieldType.Text,
    fieldLabel: $localize`To Download: Exchange Link`,
    placeholder: $localize`:placeholder:To Download: Exchange Link`,
    inputType: 'text',
    widthClass: WidthClass.WFull,
    fieldGroup: 'tagging',
    value: '',
    visible: true,
  },
];
